import type { DayOfWeekOption } from '@app/types'

export const DAY_OF_WEEK = {
  1: 'Пн',
  2: 'Вт',
  3: 'Ср',
  4: 'Чт',
  5: 'Пт',
  6: 'Сб',
  7: 'Вс'
} as const

export const DAY_OF_WEEK_OPTIONS: DayOfWeekOption[] = [
  {
    label: 'Пн',
    value: 1
  },
  {
    label: 'Вт',
    value: 2
  },
  {
    label: 'Ср',
    value: 3
  },
  {
    label: 'Чт',
    value: 4
  },
  {
    label: 'Пт',
    value: 5
  },
  {
    label: 'Сб',
    value: 6
  },
  {
    label: 'Вс',
    value: 7
  }
]
